/** CoStar.Api.PropertyComps.Enums.MonetaryUnit */
export var MonetaryUnit;
(function (MonetaryUnit) {
    MonetaryUnit[MonetaryUnit["USD"] = 1] = "USD";
    MonetaryUnit[MonetaryUnit["CAD"] = 2] = "CAD";
    MonetaryUnit[MonetaryUnit["GBP"] = 3] = "GBP";
    MonetaryUnit[MonetaryUnit["EUR"] = 4] = "EUR";
    MonetaryUnit[MonetaryUnit["AUD"] = 5] = "AUD";
    MonetaryUnit[MonetaryUnit["BRL"] = 6] = "BRL";
    MonetaryUnit[MonetaryUnit["CHF"] = 7] = "CHF";
    MonetaryUnit[MonetaryUnit["JPY"] = 8] = "JPY";
    MonetaryUnit[MonetaryUnit["SGD"] = 9] = "SGD";
    MonetaryUnit[MonetaryUnit["HKD"] = 10] = "HKD";
})(MonetaryUnit || (MonetaryUnit = {}));
/** CoStar.Api.PropertyComps.Enums.CurrencyConversionMethod */
export var CurrencyConversionMethod;
(function (CurrencyConversionMethod) {
    CurrencyConversionMethod[CurrencyConversionMethod["ConstantCurrency"] = 0] = "ConstantCurrency";
    CurrencyConversionMethod[CurrencyConversionMethod["HistoricalExchangeRate"] = 1] = "HistoricalExchangeRate";
})(CurrencyConversionMethod || (CurrencyConversionMethod = {}));
import { MeasurementSystem } from "../../../../CoStar/Api/Analytics/Enums/index.js";
/** CoStar.Api.PropertyComps.Enums.MeasurementSystem */
export { MeasurementSystem };
/** CoStar.Api.PropertyComps.Enums.AreaType */
export var AreaType;
(function (AreaType) {
    AreaType[AreaType["Unknown"] = 0] = "Unknown";
    AreaType[AreaType["Building"] = 1] = "Building";
})(AreaType || (AreaType = {}));
import { PropertySubtype } from "../../../../CoStar/Api/Analytics/Enums/index.js";
/** CoStar.Api.PropertyComps.Enums.PropertySubtype */
export { PropertySubtype };
import { ServiceType } from "../../../../CoStar/Api/Analytics/Enums/index.js";
/** CoStar.Api.PropertyComps.Enums.ServiceType */
export { ServiceType };
import { PropertyType } from "../../../../CoStar/Api/Analytics/CommonEntities/Enums/Property/index.js";
/** CoStar.Api.PropertyComps.Enums.PropertyType */
export { PropertyType };
